import { motion } from 'framer-motion'
import { useAtom, useAtomValue } from 'jotai'
import SmartButton from 'src/common/components/Buttons/SmartButton'
import {
  buyTokenAmountAtom,
  buyTokenAtom,
  sellTokenAmountAtom,
  sellTokenAtom,
} from '../../stores/trade-store'
import TokenPairSelect from '../TokenPairSelect'
import TradePricePerToken from '../TradePricePerToken'
import useSwapFormControls from './hooks/useSwapFormControls'
import useSwapFormState from './hooks/useSwapFormState'
import useSwapSyncOffers from './hooks/useSwapSyncOffers'
import { useEffect } from 'react'
import { KNOWN_TOKENS } from 'src/config/tokens/known-tokens'
import useActiveOrDefaultChain from 'src/common/hooks/web3/useActiveOrDefaultChain'

const Invest = () => {
  const chain = useActiveOrDefaultChain()
  const sellTokenAmount = useAtomValue(sellTokenAmountAtom)
  const [buyToken, setBuyToken] = useAtom(buyTokenAtom)
  const [sellToken, setSellToken] = useAtom(sellTokenAtom)
  const buyTokenAmount = useAtomValue(buyTokenAmountAtom)

  useEffect(() => {
    setBuyToken(KNOWN_TOKENS[chain.id].XCARBON)
    setSellToken(KNOWN_TOKENS[chain.id].USDC)
  }, [setBuyToken, setSellToken, chain.id])

  const { pairOffersLoading } = useSwapSyncOffers({
    sellToken,
    sellTokenAmount,
    buyToken,
    buyTokenAmount,
  })

  const {
    handleSellTokenAmountChange,
    handleBuyTokenAmountChange,
    handleBuyTokenChange,
    handleSwithToLimit,
    handlePreviewClick,
  } = useSwapFormControls()

  const {
    loading,
    actionStatusMessage,
    isActionDisabled,
    hasAvailableOffers,
    hasOffersToTake,
  } = useSwapFormState()

  return (
    <div className='flex flex-col gap-2'>
      <div className='paper p-4 col-span-1 flex flex-col gap-1'>
        <h3
          className='typo-title3 text-main-accent'
          style={{
            fontSize: '20px',
          }}
        >
          xCharNow
        </h3>
        <p className=' text-main-accent typo-label2'>
          Swarm Protocol: BiocharNow Carbon Tonne
        </p>
      </div>
      <TokenPairSelect
        titleSell='Buy with:'
        titleBuy='You receive:'
        readonlyBuy
        onSellTokenAmountChange={handleSellTokenAmountChange}
        onBuyTokenAmountChange={handleBuyTokenAmountChange}
        onBuyTokenChange={handleBuyTokenChange}
        excludeNFT
        hideSwap
      />
      {hasAvailableOffers && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <TradePricePerToken />
        </motion.div>
      )}

      <SmartButton
        className='w-full'
        loading={loading || pairOffersLoading}
        onClick={
          hasOffersToTake
            ? () => handlePreviewClick('invest')
            : handleSwithToLimit
        }
        disabled={isActionDisabled}
      >
        {actionStatusMessage}
      </SmartButton>
    </div>
  )
}

export default Invest
